export default "__VITE_ASSET__BVD_2fHR__"